export default "__VITE_ASSET__CnY2YB4r__"